import {Component, inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogClose, MatDialogContent} from '@angular/material/dialog';
import {SanitizePipe} from '../../pipes/sanitize.pipe';
import {MatIcon} from '@angular/material/icon';
import {MatIconButton} from '@angular/material/button';

@Component({
  selector: 'tgrid-information-modal',
  imports: [
    MatDialogContent,
    SanitizePipe,
    MatIcon,
    MatDialogClose,
    MatIconButton,
  ],
  templateUrl: './information-modal.component.html',
  styleUrl: './information-modal.component.scss',
  standalone: true,
})
export class InformationModalComponent {
  protected data = inject(MAT_DIALOG_DATA);
}
